// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"Loader_loading-spinner__mCMtF","spinner":"Loader_spinner__214A_","spinner-container":"Loader_spinner-container__2ZYcS"};